export default "__VITE_ASSET__BN8_wmMw__"